import { createSelector, createFeatureSelector } from '@ngrx/store';
import { UserState } from './user.state';

export const FEATURE_NAME = 'user';
export const selectUserState = createFeatureSelector<UserState>(FEATURE_NAME);

export const selectUser = createSelector(selectUserState, (state: UserState) => state);
export const selectUserId = createSelector(selectUserState, (state: UserState) => state.id);
